const INVALID_CREDENTIAL_CODES = new Set([
  'auth/invalid-credential',
  'auth/invalid-login-credentials',
  'auth/wrong-password',
  'auth/user-not-found',
]);

const LOGIN_MESSAGES = {
  'auth/invalid-email': 'Neveljaven elektronski naslov.',
  'auth/user-disabled': 'Račun je onemogočen. Obrnite se na administratorja.',
  'auth/too-many-requests': 'Preveč poskusov prijave. Poskusite znova čez nekaj minut.',
  'auth/network-request-failed': 'Ni povezave. Preverite internet in poskusite znova.',
};

const PASSWORD_CHANGE_MESSAGES = {
  'auth/weak-password': 'Novo geslo je prešibko. Uporabite močnejše geslo.',
  'auth/requires-recent-login': 'Za spremembo gesla se morate znova prijaviti.',
  'auth/too-many-requests': 'Preveč poskusov. Poskusite znova čez nekaj minut.',
  'auth/network-request-failed': 'Ni povezave. Preverite internet in poskusite znova.',
};

const PASSWORD_RESET_MESSAGES = {
  'auth/invalid-email': 'Neveljaven elektronski naslov.',
  'auth/missing-email': 'Vnesite elektronski naslov.',
  'auth/invalid-continue-uri': 'Pošiljanje povezave ni uspelo (neveljaven URL aplikacije). Odprite aplikacijo prek localhost ali uradne QA/prod domene.',
  'auth/unauthorized-continue-uri': 'Pošiljanje povezave ni uspelo (domena ni dovoljena). Odprite aplikacijo prek localhost ali uradne QA/prod domene.',
  'auth/missing-continue-uri': 'Pošiljanje povezave ni uspelo (manjka URL za nadaljevanje).',
  'auth/too-many-requests': 'Preveč poskusov. Poskusite znova čez nekaj minut.',
  'auth/network-request-failed': 'Ni povezave. Preverite internet in poskusite znova.',
};

const EMAIL_UPDATE_MESSAGES = {
  'auth/invalid-email': 'Neveljaven elektronski naslov.',
  'auth/missing-email': 'Vnesite elektronski naslov.',
  'auth/email-already-in-use': 'Ta elektronski naslov je že v uporabi.',
  'auth/requires-recent-login': 'Za spremembo elektronskega naslova se morate znova prijaviti.',
  'auth/too-many-requests': 'Preveč poskusov. Poskusite znova čez nekaj minut.',
  'auth/network-request-failed': 'Ni povezave. Preverite internet in poskusite znova.',
  'auth/invalid-continue-uri': 'Pošiljanje povezave ni uspelo (neveljaven URL aplikacije).',
  'auth/unauthorized-continue-uri': 'Pošiljanje povezave ni uspelo (domena ni dovoljena).',
  'auth/missing-continue-uri': 'Pošiljanje povezave ni uspelo (manjka URL za nadaljevanje).',
};

const DEFAULT_MESSAGES = {
  login: 'Prijava ni uspela. Poskusite znova.',
  passwordChange: 'Sprememba gesla ni uspela. Poskusite znova.',
  passwordReset: 'Pošiljanje povezave ni uspelo. Poskusite znova pozneje.',
  emailUpdate: 'Sprememba elektronskega naslova ni uspela. Poskusite znova.',
};

/**
 * Map Firebase Auth errors to user-facing Slovenian copy.
 * @param {unknown} error
 * @param {{ context?: 'login' | 'passwordChange' | 'passwordReset' | 'emailUpdate' }} [options]
 */
export function resolveFirebaseAuthError(error, options = {}) {
  const context = options.context || 'login';
  const code = String(error?.code || '').trim();

  if (INVALID_CREDENTIAL_CODES.has(code)) {
    if (context === 'passwordChange') {
      return 'Trenutno geslo je napačno.';
    }
    return 'Napačen elektronski naslov ali geslo. Preverite podatke ali ponastavite geslo.';
  }

  if (context === 'login' && LOGIN_MESSAGES[code]) {
    return LOGIN_MESSAGES[code];
  }

  if (context === 'passwordChange' && PASSWORD_CHANGE_MESSAGES[code]) {
    return PASSWORD_CHANGE_MESSAGES[code];
  }

  if (context === 'passwordReset' && PASSWORD_RESET_MESSAGES[code]) {
    return PASSWORD_RESET_MESSAGES[code];
  }

  if (context === 'emailUpdate' && EMAIL_UPDATE_MESSAGES[code]) {
    return EMAIL_UPDATE_MESSAGES[code];
  }

  return DEFAULT_MESSAGES[context] || DEFAULT_MESSAGES.login;
}
